import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white mt-12">
      <div className="container-custom py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Yugal Kunj</h3>
            <p className="text-gray-400 text-sm">
              Providing quality programs for spiritual and cultural development.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Programs</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="https://ykportal.yugalkunj.org/Home/CountrySelect" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Camp</a></li>
              <li><a href="https://ykportal.yugalkunj.org/Home/CountrySelect" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Retreat</a></li>
              <li><a href="#/class/center" className="hover:text-white transition">Class</a></li>
              <li><a href="https://ykportal.yugalkunj.org/Home/CountrySelect" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Tiffin</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="https://ykportal.yugalkunj.org/home/contact" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Contact Us</a></li>
              <li><a href="#" className="hover:text-white transition">FAQ</a></li>
              <li><a href="#" className="hover:text-white transition">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white transition">Terms of Service</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <p className="text-gray-400 text-sm mb-2">
              Email: info@yugalkunj.org
            </p>
            <p className="text-gray-400 text-sm">
              Phone: (555) 123-4567
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <p className="text-center text-gray-400 text-sm">
            &copy; 2024 Yugal Kunj. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
